import * as React from "react";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
/* global Spinner */

export interface ProgressLoginProps {
  logo: string;
  message: string;
  title: string;
}

export default class ProgressLogin extends React.Component<ProgressLoginProps> {
  render() {
    const { logo, message, title } = this.props;

    return (
      <section className="ms-welcome__progress ms-u-fadeIn500">
        <img width="290" height="63" src={logo} alt={title} title={title} />
        <h1 className="ms-fontSize-su ms-fontWeight-light ms-fontColor-neutralPrimary">{title}</h1>
        <Spinner size={SpinnerSize.large} label={message} />
      </section>
    );
  }
}
